import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SalesOrderLookupComponent } from './sales-order-lookup.component';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [SalesOrderLookupComponent],
  exports: [SalesOrderLookupComponent]
})
export class SalesOrderLookupModule { }
